import { useMemo } from "react"
import useFeatureFlags from "hooks/useFeatureFlags"
import { REQUIRED_FEATURE_FLAGS } from "helpers/sf_constants"

const useIsLeadIntegrationsV2Enabled = () => {
  const [isFeatureFlagActive] = useFeatureFlags()

  return useMemo(
    () => isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_LEAD_INTEGRATIONS_V2_OPTIMIZATION),
    [isFeatureFlagActive]
  )
}

export default useIsLeadIntegrationsV2Enabled
